import React from 'react';
import {Typography} from "@mui/material";
import LoggedLayout from "../../component/LoggedLayout";

 const GuildView = () => {
    return (
        <LoggedLayout>
            <Typography>Guild view</Typography>
        </LoggedLayout>
    )
}

export default GuildView